import { timeline } from "@/mocks/dramaData";

const typeColor: Record<string, { dot: string; badge: string }> = {
  官宣: { dot: "bg-primary-500", badge: "bg-primary-100 text-primary-800" },
  音乐: { dot: "bg-accent-500", badge: "bg-accent-100 text-accent-800" },
  综艺: { dot: "bg-secondary-500", badge: "bg-secondary-100 text-secondary-900" },
  商业: { dot: "bg-primary-400", badge: "bg-primary-100 text-primary-800" },
  体坛: { dot: "bg-accent-400", badge: "bg-accent-100 text-accent-800" },
  影视: { dot: "bg-secondary-400", badge: "bg-secondary-100 text-secondary-900" },
};

export default function Timeline() {
  return (
    <section id="timeline" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-800">
            <i className="ri-time-line"></i> 本月大瓜全记录
          </span>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">
            按时间线，复盘本月大事
          </h2>
          <p className="mt-3 text-sm text-foreground-700 md:text-base">
            重要事件与关键节点按倒序排列，完整串联本月脉络，中途没跟进也能快速补课。
          </p>
        </div>

        <div className="relative mx-auto mt-12 max-w-3xl">
          <span className="absolute left-[27px] top-2 bottom-2 w-0.5 rounded bg-background-300 md:left-1/2 md:-translate-x-1/2"></span>
          <div className="flex flex-col gap-8">
            {timeline.map((item, i) => {
              const c = typeColor[item.type] || typeColor.官宣;
              const left = i % 2 === 0;
              return (
                <article key={item.date} className="relative flex items-start gap-4 md:gap-0">
                  <span className="absolute left-0 flex h-14 w-14 items-center justify-center md:left-1/2 md:-translate-x-1/2">
                    <span className={`relative z-10 flex h-6 w-6 items-center justify-center rounded-full ring-4 ring-background-100 ${c.dot}`}>
                      <span className="h-2 w-2 rounded-full bg-background-50"></span>
                    </span>
                  </span>

                  <div
                    className={`ml-20 w-full rounded-2xl border border-background-200 bg-background-50 p-5 md:ml-0 md:w-[calc(50%-48px)] ${
                      left ? "md:mr-auto" : "md:ml-auto"
                    }`}
                  >
                    <div className="flex flex-wrap items-center gap-2">
                      <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-bold ${c.badge}`}>
                        {item.type}
                      </span>
                      <span className="whitespace-nowrap text-xs font-semibold text-foreground-700">
                        {item.date} · {item.week}
                      </span>
                    </div>
                    <h3 className="mt-3 font-heading text-base font-bold text-foreground-950 md:text-lg">{item.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.text}</p>
                  </div>
                </article>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}